/**
 * Tastenbefehle, wählbar.
 *
 * Wer aus Final Cut kommt, drückt B zum Trennen; wer aus DaVinci kommt, ⌘B.
 * Beides ist richtig -- falsch ist nur, jemandem die dritte Variante
 * aufzuzwingen. Deshalb eine Tabelle je Belegung statt einer Kette von ifs im
 * Editor: hier steht sie an einem Ort, ist prüfbar, und die App kann sie
 * auch anzeigen.
 *
 * Die Nachbildungen sind bewusst die *wichtigsten* Befehle, nicht die
 * vollständige Belegung der beiden Programme -- alles andere wäre ein
 * Versprechen, das wir nicht halten.
 */
export const KEY_SCHEMES = [
    { id: 'schnitt', label: 'SHA TV Schnitt', hint: 'Unsere eigene, auf das Nötige beschränkt.' },
    { id: 'finalcut', label: 'wie Final Cut', hint: 'B trennt, ⇧← springt zehn Bilder.' },
    { id: 'davinci', label: 'wie DaVinci', hint: '⌘B trennt, ⇧← springt eine Sekunde.' },
];
const GEMEINSAM = [
    { action: 'play', key: ' ', label: 'Leertaste' },
    { action: 'undo', key: 'z', mod: true, label: '⌘Z' },
    { action: 'redo', key: 'z', mod: true, shift: true, label: '⇧⌘Z' },
    { action: 'copy', key: 'c', mod: true, label: '⌘C' },
    { action: 'paste', key: 'v', mod: true, label: '⌘V' },
    { action: 'duplicate', key: 'd', mod: true, label: '⌘D' },
    { action: 'delete', key: 'Delete', label: 'Entf' },
    { action: 'delete', key: 'Backspace', label: '⌫' },
    { action: 'frameBack', key: 'ArrowLeft', label: '←' },
    { action: 'frameForward', key: 'ArrowRight', label: '→' },
    { action: 'prevCut', key: 'ArrowUp', label: '↑' },
    { action: 'nextCut', key: 'ArrowDown', label: '↓' },
    { action: 'keyframe', key: 'k', label: 'K' },
    // I und O für Anfang und Ende eines Bereichs (18. September: „Bereiche
    // müssen besser erreichbar sein“). In Final Cut, Premiere und DaVinci
    // dieselben zwei Tasten -- wer von dort kommt, drückt sie ohnehin.
    { action: 'bereichVon', key: 'i', label: 'I' },
    { action: 'bereichBis', key: 'o', label: 'O' },
    // Alt mit den Pfeilen: in keinem der drei Programme belegt, und nah an den
    // Pfeilen, mit denen man ohnehin durch die Zeit geht.
    { action: 'prevKeyframe', key: 'ArrowLeft', alt: true, label: '⌥←' },
    { action: 'nextKeyframe', key: 'ArrowRight', alt: true, label: '⌥→' },
];
const SCHEMES = {
    schnitt: [
        ...GEMEINSAM,
        { action: 'split', key: 's', label: 'S' },
        { action: 'jumpBack', key: 'ArrowLeft', shift: true, label: '⇧← (1 s)' },
        { action: 'jumpForward', key: 'ArrowRight', shift: true, label: '⇧→ (1 s)' },
    ],
    finalcut: [
        ...GEMEINSAM,
        // In Final Cut ist B die Klinge, und ⇧ mit den Pfeilen springt zehn Bilder.
        { action: 'split', key: 'b', label: 'B' },
        { action: 'jumpBack', key: 'ArrowLeft', shift: true, label: '⇧← (10 Bilder)' },
        { action: 'jumpForward', key: 'ArrowRight', shift: true, label: '⇧→ (10 Bilder)' },
    ],
    davinci: [
        ...GEMEINSAM,
        // In DaVinci schneidet ⌘B, und ⇧ mit den Pfeilen springt eine Sekunde.
        { action: 'split', key: 'b', mod: true, label: '⌘B' },
        { action: 'jumpBack', key: 'ArrowLeft', shift: true, label: '⇧← (1 s)' },
        { action: 'jumpForward', key: 'ArrowRight', shift: true, label: '⇧→ (1 s)' },
    ],
};
/** Wie weit ⇧ mit den Pfeilen springt: in Bildern, oder eine Sekunde. */
export function jumpFrames(scheme, fps) {
    return scheme === 'finalcut' ? 10 : Math.max(1, Math.round(fps));
}
function passt(binding, press) {
    const key = press.key.length === 1 ? press.key.toLowerCase() : press.key;
    const wanted = binding.key.length === 1 ? binding.key.toLowerCase() : binding.key;
    if (key !== wanted)
        return false;
    const mod = Boolean(press.meta || press.ctrl);
    if (Boolean(binding.mod) !== mod)
        return false;
    if (Boolean(binding.alt) !== Boolean(press.alt))
        return false;
    return Boolean(binding.shift) === Boolean(press.shift);
}
export function keyAction(scheme, press) {
    // Die längere Bedingung zuerst: ⇧⌘Z ist Wiederherstellen, nicht Rückgängig
    // mit einem zufälligen ⇧ daneben.
    const bindings = [...SCHEMES[scheme]].sort((a, b) => Number(Boolean(b.shift)) + Number(Boolean(b.alt)) - (Number(Boolean(a.shift)) + Number(Boolean(a.alt))));
    return bindings.find((b) => passt(b, press))?.action ?? null;
}
/** Die Belegung zum Anzeigen, eine Zeile je Befehl. */
export function keyHints(scheme) {
    const seen = new Map();
    for (const b of SCHEMES[scheme])
        seen.set(b.action, [...(seen.get(b.action) ?? []), b.label]);
    return [...seen].map(([action, labels]) => ({ action, keys: labels.join(' / ') }));
}
//# sourceMappingURL=keys.js.map